import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissTextField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function FormFilterCentroPedidos() {
    const [filterIdCentroPedido, setFilterIdCentroPedido] = useState<FilterValuesProps>({
        property: 'idCentroPedido',
        operator: 'like',
        value: null,
        idProperty: 'idCentroPedido',
    });
    const [filterDsCentroPedido, setFilterDsCentroPedido] = useState<FilterValuesProps>({
        property: 'dsCentroPedido',
        operator: 'like',
        value: null,
        idProperty: 'dsCentroPedido',
    });
    const [filterCdCentroPedido, setFilterCdCentroPedido] = useState<FilterValuesProps>({
        property: 'cdCentroPedido',
        operator: 'like',
        value: null,
        idProperty: 'cdCentroPedido',
    });
    const [fgAtivo, setFgAtivo] = useState<FilterValuesProps>({
        property: 'fgAtivo',
        operator: 'eq',
        value: true,
        idProperty: 'fgAtivo',
    });

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterIdCentroPedido, setter: setFilterIdCentroPedido },
                { value: filterDsCentroPedido, setter: setFilterDsCentroPedido },
                { value: filterCdCentroPedido, setter: setFilterCdCentroPedido },
                { value: fgAtivo, setter: setFgAtivo },
            ]}
        >
            <Grid sx={{ flex: 4 }}>
                <CissTextField
                    label="Código"
                    value={filterIdCentroPedido.value}
                    style={{ marginBottom: 20 }}
                    onChange={(e) => setFilterIdCentroPedido((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid sx={{ flex: 4 }}>
                <CissTextField
                    label="Nome do centro"
                    value={filterDsCentroPedido.value}
                    onChange={(e) => setFilterDsCentroPedido((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid sx={{ flex: 4 }}>
                <CissTextField
                    label="Código de Integração"
                    value={filterCdCentroPedido.value}
                    onChange={(e) => setFilterCdCentroPedido((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
        </Filter>
    );
}
